import { dbShortDate } from 'utilities';
import { ComparisonByDate, ComparisonsByCapIqId, GetComparisonsByDateParams } from './getComparisonsByDate.types';

const getComparisonsByDate = (params: GetComparisonsByDateParams): ComparisonByDate[] => {
  const { asOfDate, comparisons, marketDate } = params;

  if (!comparisons) {
    return [];
  }

  const grouped = comparisons.reduce((accumulator, current) => {
    const { as_of_date: comparisonAsOfDate, cap_iq_id: capIqId, ticker_symbol: tickerSymbol } = current;

    if (!capIqId) {
      return accumulator;
    }

    const isAsOfDate = dbShortDate(comparisonAsOfDate) === dbShortDate(asOfDate);
    const isAsOfMarketDate = dbShortDate(comparisonAsOfDate) === dbShortDate(marketDate);

    const previousEntry = accumulator[capIqId] ?? {
      cap_iq_id: capIqId,
      ticker_symbol: tickerSymbol,
    };

    const updated: ComparisonByDate = {
      ...previousEntry,
      ...(isAsOfDate && { as_of_date: current }),
      ...(isAsOfMarketDate && { as_of_market_date: current }),
    };

    return {
      ...accumulator,
      [capIqId]: updated,
    };
  }, {} as ComparisonsByCapIqId);

  return Object.values(grouped);
};

export default getComparisonsByDate;
